/**
 * tdesign v0.44.2
 * (c) 2022 tdesign
 * @license MIT
 */

import Popup$1 from './Popup.js';
import './style/index.js';
import './type.js';
import '../_chunks/dep-74ef9ead.js';
import '../_chunks/dep-784849f3.js';
import '../_chunks/dep-d6cc3db8.js';
import 'react';
import 'react-transition-group';
import '../_chunks/dep-670cc86e.js';
import '../_chunks/dep-7a9656a6.js';
import '../_chunks/dep-da112583.js';
import '../_chunks/dep-dfae10c3.js';
import '../_chunks/dep-f4495ac9.js';
import '../_chunks/dep-6c09308a.js';
import 'classnames';
import 'react-popper';
import '../hooks/useControlled.js';
import '../_chunks/dep-41dfd063.js';
import '../_chunks/dep-0b195c48.js';
import '../_chunks/dep-04371a7c.js';
import '../_chunks/dep-935ff614.js';
import '../_chunks/dep-1792ab93.js';
import '../_chunks/dep-4929b64e.js';
import '../_chunks/dep-1e4c771d.js';
import '../_util/noop.js';
import '../_util/useAnimation.js';
import '../hooks/useConfig.js';
import '../config-provider/ConfigContext.js';
import '../_chunks/dep-5eadc4f3.js';
import '../_chunks/dep-fd215ab0.js';
import '../_chunks/dep-8127363b.js';
import '../_chunks/dep-a0b71ae4.js';
import '../_chunks/dep-4ca52001.js';
import '../_chunks/dep-408df89a.js';
import '../_chunks/dep-e755a9cb.js';
import '../_chunks/dep-15d0e734.js';
import '../_chunks/dep-b0c02324.js';
import '../_chunks/dep-a09b6dac.js';
import '../_chunks/dep-9c2f4c72.js';
import '../_chunks/dep-da7344ec.js';
import '../_chunks/dep-01fe0fd1.js';
import '../_chunks/dep-20a8e46d.js';
import '../_chunks/dep-9d067299.js';
import '../locale/zh_CN.js';
import '../_common/js/global-config/locale/zh_CN.js';
import '../_common/js/global-config/default-config.js';
import '../common/Portal.js';
import 'react-dom';
import '../_util/dom.js';
import 'raf';
import '../_chunks/dep-10140b37.js';
import '../_util/easing.js';
import './hooks/useTrigger.js';
import 'react-is';
import './utils/ref.js';
import '../_util/composeRefs.js';
import './utils/transition.js';
import '../_util/useMutationObserver.js';
import '../_chunks/dep-407a3536.js';
import '../_chunks/dep-762fb0bd.js';
import '../_util/useWindowSize.js';
import './defaultProps.js';

var Popup = Popup$1;

export { Popup, Popup as default };
//# sourceMappingURL=index.js.map
